import { SummaryCard } from '../../../types';

export const ingilizceCards: SummaryCard[] = [];